import { HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RequirePrivileges } from "app/auth/privileges/privileges.decorator";
import { TenantConfig } from "app/core/models/tenant-config.interface";
import { Tenant } from "app/core/models/tenant.interface";
import { Observable } from "rxjs";
import { STATIC_PRIVILEGES } from "../auth/privileges/static-privileges";
import { AbstractApiService } from "./abstract.api.service";
import { SKIP_GLOBAL_TOAST } from "./http-context.token";

@Injectable()
export class TenantApiService extends AbstractApiService {
    constructor() {
        super();
    }

    //   _____                  _
    //  |_   _|__ _ _  __ _ _ _| |_
    //    | |/ -_) ' \/ _` | ' \  _|
    //    |_|\___|_||_\__,_|_||_\__|

    getTenantInfo(): Observable<Tenant> {
        return this.http.get<Tenant>(`${this.baseUrl}/tenant/info`, {
            context: new HttpContext().set(SKIP_GLOBAL_TOAST, true),
        });
    }

    @RequirePrivileges(
        STATIC_PRIVILEGES.CONFIGURATION.SETTINGS.TENANT_AVATAR_MANAGE,
    )
    updateTenantPhoto(file: File): Observable<string> {
        const formData = new FormData();
        formData.append("file", file);
        return this.http.post(`${this.baseUrl}/tenant/info/photo`, formData, {
            responseType: "text",
        });
    }

    @RequirePrivileges(
        STATIC_PRIVILEGES.CONFIGURATION.SETTINGS.TENANT_AVATAR_MANAGE,
    )
    deleteTenantPhoto(): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/tenant/info/photo`);
    }

    getTenantConfig(): Observable<TenantConfig> {
        return this.http.get<TenantConfig>(`${this.baseUrl}/tenant/config`, {
            context: new HttpContext().set(SKIP_GLOBAL_TOAST, true),
        });
    }

    @RequirePrivileges(
        STATIC_PRIVILEGES.CONFIGURATION.SETTINGS.TENANT_CONFIG_UPDATE,
    )
    setTenantConfig(config: TenantConfig): Observable<TenantConfig> {
        return this.http.put<TenantConfig>(
            `${this.baseUrl}/tenant/config`,
            config,
        );
    }
}
